<template>
  <confirmationModal
    v-bind="$attrs"
    v-on="$listeners"
    :title="`Are you sure you want to promote to ${nextEnvironment}`"
    @closeModal="closeModal"
  >
    <p class="subtitle-1">
      You are about to promote
      <span class="client-count">{{ promoteClients.length }}</span>
      {{ clientText }}
      to
      {{ nextEnvironment }}
    </p>
    <template #buttons>
      <qvoButton text @click="closeModal">Cancel</qvoButton>
      <qvoButton @click="promote">Yes, Promote</qvoButton>
    </template>
  </confirmationModal>
</template>
    
<script>
import { mapGetters } from "vuex";

import qvoButton from "@/qux-common/qux22/components/molecules/button";
import confirmationModal from "@/components/confirmation-modal";

export default {
  name: "PromoteConfirmation",
  components: {
    confirmationModal,
    qvoButton,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    promote() {
      this.$store.dispatch("promote", {
        clients: this.promoteClients,
      });
      this.$emit("closeModal");
    },
  },
  computed: {
    clientText() {
      return this.promoteClients.length !== 1 ? "clients" : "client";
    },
    ...mapGetters({
      promoteClients: "getPromoteClients",
      nextEnvironment: "getNextEnvironment",
    }),
  },
};
</script>
    
<style lang="scss" scoped>
.client-count {
  color: $qvo-color-red-300;
}
</style>